// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1bbc2e96","453":"d3ed2924","544":"9fc12479","546":"25a68cd3","660":"0b878c00","825":"acc93b95"}[chunkId] + ".chunk.js";
};